import { FC, memo, ReactElement } from 'react'

import Parallax from '../../components/parallax'
import { ParallaxProps } from '../../components/parallax/types'

import './index.css'

type FindMySchoolPageTopBannerProps = {
  title: string
  description: string[]
  parallax: ParallaxProps
}

const FindMySchoolPageTopBanner: FC<FindMySchoolPageTopBannerProps> = (props): ReactElement => {
  const { title, parallax, description } = props
  return (
    <Parallax classNames={parallax.classNames} bgPosition={parallax.bgPosition} imgData={parallax.imgData} isStatic={parallax.isStatic}>
      <div className="find-my-school-top-banner-wrapper">
        <h1 className="find-my-school-top-banner-title">{title.toUpperCase()}</h1>
        <div className="find-my-school-top-banner-description-wrapper">
          {description.map((d, i) => (
            <p key={d + i} className={`banner-subtitle find-my-school-top-banner-description-${i + 1}`}>
              {d}
            </p>
          ))}
        </div>
      </div>
    </Parallax>
  )
}
export default memo(FindMySchoolPageTopBanner)
